import React from "react";
import NavBar from "../../components/navBar/NavBar";

import "../../assets/style/style.css";
import axios from "axios";

//import ptBr from "moment/locale/pt-br";

import "react-dates/initialize";

//import './App.css';

require("dotenv").config();

const url = process.env.REACT_APP_API_TASK;

class FormClient extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nome_fantasia: ""
    };
  }
  componentDidMount() {
    const tokenLocal = localStorage.getItem("token");
    this.getFormClient(this.props.match.params.idFormulario, tokenLocal);
  }

  getFormClient = (idViabilidade, token) => {
    const objForm = { idViabilidade: idViabilidade, token: token };
    axios
      .post(
        `${url}/getFormularioTecnico`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        this.setState({
          nomeFantasia: response.data.resultFormulario[0].nome_fantasia,
          idViabilidade: response.data.resultFormulario[0].viabilidade_id,
          razaoSocial: response.data.resultFormulario[0].razao_social,
          gerenteContas: response.data.resultFormulario[0].gerente_contas,
          tipo: response.data.resultFormulario[0].tipo,
          descricaoOutro: response.data.resultFormulario[0].descricao_outro,
          andares: response.data.resultFormulario[0].andares,
          andarRoteador: response.data.resultFormulario[0].andar_roteador,
          nome: response.data.resultFormulario[0].nome,
          telefoneFixo: response.data.resultFormulario[0].telefone_fixo,
          telefoneCelular: response.data.resultFormulario[0].telefone_celular,
          email: response.data.resultFormulario[0].email,
          cargo: response.data.resultFormulario[0].cargo,
          autorizacao: response.data.resultFormulario[0].autorizacao,
          criterio: response.data.resultFormulario[0].criterio,
          autorizacaoInstalacao:
            response.data.resultFormulario[0].autorizacao_instalacao,
          criterioInstalacao:
            response.data.resultFormulario[0].criterio_instalacao,
          data: response.data.resultFormulario[0].data,
          segurancaTrabalho:
            response.data.resultFormulario[0].seguranca_trabalho,
          integracaoEquipe: response.data.resultFormulario[0].integracao_equipe,
          acompanhamentoInstalacao:
            response.data.resultFormulario[0].acompanhamentoInstalacao,
          criterioAcompanhamento:
            response.data.resultFormulario[0].criterio_acompanhamento
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/task-descriptions/${this.props.match.params.id}`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            <div className="card marginTop6">
              <h5 className="card-header">Informaçoes Técnica do Cliente</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="id">ID Viabilidade</label>
                  <input
                    type="text"
                    className="form-control"
                    id="id"
                    defaultValue={this.state.idViabilidade}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Nome Fantasia</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.nomeFantasia}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Razão Social</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.razaoSocial}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Gerente Comercial</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.gerenteContas}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Tipo de Edifício</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.tipo}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Descrição Outro</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.descricaoOutro}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Andares</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.andares}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Andar Roteador</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.andarRoteador}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.nome}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Telefone Fixo</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.telefoneFixo}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Telefone Celular</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.telefoneCelular}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">E-mail</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.email}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Cargo</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.cargo}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Autorização</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.autorizacao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Critério</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.criterio}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Autorização de Instalação</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.autorizacaoInstalacao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Critério de Instalação</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.criterioInstalacao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Data</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.data}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Segurança do Trabalho</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.segurancaTrabalho}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Integração Equipe</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.integracaoEquipe}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Acompanhamento Instalação</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.acompanhamentoInstalacao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Critério de Acompanhamento</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.criterioAcompanhamento}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default FormClient;
